import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { dateReportFormatter } from "../../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function Adjustment() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [agent, setAgent] = useState("");
  const onAgentChange = useCallback(
    (event) => setAgent(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [profile, setProfile] = useState("");
  const onProfileChanged = useCallback((p) => setProfile(p), []);
  const { values: profiles } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetPlayerProfile`,
  });

  const [limitProfile, setLimitProfile] = useState("");
  const onLimitProfileChanged = useCallback((lp) => setLimitProfile(lp), []);
  const { values: limitProfiles } = useDataFormatterHook({
    addEmpty: true,
    value: "profileName",
    text: "profileName",
    path: `/Player/GetPlayerProfileLimits`,
  });

  const [filterBy, setFilterBy] = useState(0);
  const onFilterByChange = useCallback(
    (event) => setFilterBy(Number(event.target.value)),
    []
  );

  const [adjType, setAdjType] = useState(0);
  const onAdjTypeChange = useCallback(
    (event) => setAdjType(Number(event.target.value)),
    []
  );

  const [orderBy, setOrderBy] = useState(0);
  const onOrderByChange = useCallback(
    (event) => setOrderBy(Number(event.target.value)),
    []
  );

  const [creditLimit, setCreditLimit] = useState(0);
  const onCreditLimitChange = useCallback(
    (event) => setCreditLimit(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Profile"
          name="name"
          data={profiles}
          placeholder="DataFormatter"
          setSelectValue={onProfileChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Profile Limits"
          name="name"
          data={limitProfiles}
          placeholder="DataFormatter"
          setSelectValue={onLimitProfileChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent"
          type="text"
          value={agent}
          size="small"
          onChange={onAgentChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />

        <SubGroup title="Filter By">
          <FormControl component="fieldset">
            <RadioGroup label value={filterBy} onChange={onFilterByChange} row>
              <FormControlLabel
                control={<Radio value={0} size="small" color="primary" />}
                label="Placed Date"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={1} size="small" color="primary" />}
                label="Applied Date"
                labelPlacement="end"
              />
            </RadioGroup>
          </FormControl>
        </SubGroup>
        <SubGroup title="Type">
          <FormControl component="fieldset">
            <RadioGroup label value={adjType} onChange={onAdjTypeChange} row>
              <FormControlLabel
                control={<Radio value={0} size="small" color="primary" />}
                label="All"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={1} size="small" color="primary" />}
                label="Adjustment"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={2} size="small" color="primary" />}
                label="Accrual"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={3} size="small" color="primary" />}
                label="Horses"
                labelPlacement="end"
              />
            </RadioGroup>
          </FormControl>
        </SubGroup>
        <SubGroup title="Order By">
          <FormControl component="fieldset">
            <RadioGroup label value={orderBy} onChange={onOrderByChange} row>
              <FormControlLabel
                control={<Radio value={0} size="small" color="primary" />}
                label="Account"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={1} size="small" color="primary" />}
                label="Placed Date"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={2} size="small" color="primary" />}
                label="Settled Date"
                labelPlacement="end"
              />
            </RadioGroup>
          </FormControl>
        </SubGroup>
        <SubGroup title="Credit Limits">
          <FormControl component="fieldset">
            <RadioGroup
              label
              value={creditLimit}
              onChange={onCreditLimitChange}
              row
            >
              <FormControlLabel
                control={<Radio value={0} size="small" color="primary" />}
                label="All"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={1} size="small" color="primary" />}
                label="Credit Limit = 0"
                labelPlacement="end"
              />
              <FormControlLabel
                control={<Radio value={2} size="small" color="primary" />}
                label="Credit Limit <> 0"
                labelPlacement="end"
              />
            </RadioGroup>
          </FormControl>
        </SubGroup>
      </div>
      <Report
        title="Adjustment Report"
        getUrl={() => "/Reports/Report_Adjustment"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          Office: office,
          Group: group,
          LineType: lineType,
          Profile: profile,
          ProfileLimits: limitProfile,
          Distributor: distributor,
          Agent: agent,
          FilterBy: filterBy,
          AdjType: adjType,
          OrderBy: orderBy,
          CreditLimit: creditLimit,
        })}
        getTotals={(data) => ({
          placedDate: "Total Adjustment",
          amount: data?.[0]?.totalAmount,
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="account">
          Account
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="lastModification"
          dataFormat={dateReportFormatter}
        >
          Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="transactionType">
          Type
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="paymentMethod">
          Method
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="description">
          Description
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="officeName">
          Office
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="bookName">
          Book
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent">
          Agent
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="loginName">
          User
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="placedDate"
          dataFormat={dateReportFormatter}
        >
          Placed Date
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="amount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Amount
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default Adjustment;
